import { BASE } from '@/config'
import store from "@/store";

// Компоненты и роуты для роли
const AdminIndex = () => import("@/views/admin/Index.vue")
const MainPageView = () => import("@/views/admin/MainPageView.vue")
const StudentsView = () => import("@/views/admin/users/StudentsView.vue")
const TeachersView = () => import("@/views/admin/users/TeachersView.vue")
const TeachersVisitsView = () => import("@/views/admin/passages/TeachersVisitsView.vue")
const StudentsVisitsView = () => import("@/views/admin/passages/StudentsVisitsView.vue")
const GuestsVisitsViews = () => import("@/views/admin/passages/GuestsVisitsView.vue")
const CardActionsView = () => import("@/views/admin/card/CardActionsView.vue")
const CardsBlockedView = () => import("@/views/admin/card/CardsBlockedView.vue")
const CardsManagementView = () => import("@/views/admin/card/CardsManagementView.vue")
const ExternalCardsManagementView = () => import("@/views/admin/card/ExternalCardsManagementView.vue")
const CardsDeletedView = () => import("@/views/admin/card/CardsDeletedView.vue")
const ReportsView = () => import("@/views/admin/ReportsView.vue")
const SelfNotificationsView = () => import("@/views/admin/notifications/SelfNotificationsView.vue")
const OtherNotificationsView = () => import("@/views/admin/notifications/OtherNotificationsView.vue")

export default {
  path: "/admin",
  component: AdminIndex,
  meta: { role: BASE.ROLES.ADMIN },
  children: [
    {
      path: "",
      name: "MainPageAdmin",
      component: MainPageView,
      meta: { label: "Главная" }
    },
    {
      path: "cards",
      name: "CardsManagementAdmin",
      component: CardsManagementView,
      meta: { label: "Управление картами" }
    },
    {
      path: "external-cards",
      name: "ExternalCardsManagementAdmin",
      component: ExternalCardsManagementView,
      meta: { label: "Управление внешними картами" }
    },
    {
      path: "cards-blocked",
      name: "CardsBlockedAdmin",
      component: CardsBlockedView,
      meta: { label: "Блокированные карты" }
    },
    {
      path: "cards-deleted",
      name: "CardsDeletedAdmin",
      component: CardsDeletedView,
      meta: { label: "Удалённые карты" }
    },
    {
      path: "cards-actions",
      name: "CardActionsAdmin",
      component: CardActionsView,
      meta: { label: "Реестр действий с картой" }
    },
    {
      path: "students",
      name: "StudentsAdmin",
      component: StudentsView,
      meta: { label: "Ученики" }
    },
    {
      path: "teachers",
      name: "TeachersAdmin",
      component: TeachersView,
      meta: { label: "Сотрудники" }
    },
    {
      path: "teachers-visits",
      name: "TeachersVisitsAdmin",
      component: TeachersVisitsView,
      meta: { label: "Реестр проходов (сотрудники)" }
    },
    {
      path: "students-visits",
      name: "StudentsVisitsAdmin",
      component: StudentsVisitsView,
      meta: { label: "Реестр проходов (ученики)" }
    },
    {
      path: "guests-visits",
      name: "GuestsVisitsAdmin",
      component: GuestsVisitsViews,
      meta: { label: "Реестр гостевых проходов" }
    },
    {
      path: "self-notifications",
      name: "SelfNotificationsAdmin",
      component: SelfNotificationsView,
      meta: { label: "Личные Уведомления" }
    },
    {
      path: "other-notifications",
      name: "OtherNotificationsAdmin",
      component: OtherNotificationsView,
      meta: { label: "Другие Уведомления" }
    },
    {
      path: "reports",
      name: "ReportsViewAdmin",
      component: ReportsView,
      meta: { label: "Отчёты" }
    }
  ],
  beforeEnter(to, from, next) {
    const { state: { common: { user: { tokenData }}}} = store
    if (tokenData !== null && !tokenData.is_connected) {
      next({ name: 'NoSchoolConnectedView' })
      return
    }
    next()
  }
};
